export enum PayrollScaleSystemicType {
NoneSystemic,
FMY,
}
